<template>
  <div class="max-w-screen-lg mx-auto">
    <picture-input
      ref="pictureInput"
      width="2500"
      height="1500"
      accept="image/jpeg, image/png"
      size="10"
      :zIndex="1"
      :hideChangeButton="true"
      :custom-strings="{
        upload: 'ภาพหน้าปก',
        drag: 'เลือกภาพหน้าปก',
      }"
      @change="onFeaturedImageChange"
    />

    <a-form-item label="หัวข้อ" class="mt-12">
      <a-input
        v-model="title"
        style=""
        v-decorator="['note', { rules: [{ required: true, message: 'เนื้อหา' }] }]"
      />
    </a-form-item>

    <!-- <a-form-item label="หมวดหมู่">
      <a-select
        v-model="categoryId"
        id="category"
        show-search
        placeholder="เลือกหมวดหมู่"
        :filter-option="filterOption"
        style="width: 512px"
      >
        <a-select-option
          v-for="option in categoryOptions"
          :key="option.id"
          :value="option.id"
        >
          {{ option.name }}
        </a-select-option>
      </a-select>
    </a-form-item> -->

    <a-form-item label="เนื้อหา">
      <editor @change="(html) => (content = html)" :content="content" />
    </a-form-item>

    <a-form-item label="ลิงค์อ้างอิง">
      <a-input
        v-model="refUrl"
        style=""
        v-decorator="['refUrl', { rules: [{ required: true, message: 'ลิงค์อ้างอิง' }] }]"
      />
    </a-form-item>

    <a-form-item label="เลือกกลุ่มผู้รับ (เลือกได้มากกว่า 1 กลุ่ม)">
      <a-checkbox-group
        v-model="targets"
        :options="[
          {
            label: `ผู้มีความเสี่ยงสุขภาพสูง`,
            value: 'HEALTH_HIGH_RISK',
          },
          {
            label: `ผู้มีความเสี่ยงสุขภาพปานกลาง `,
            value: 'HEALTH_MEDIUM_RISK',
          },
          {
            label: `ผู้มีความเสี่ยงสุขภาพต่ำ `,
            value: 'HEALTH_LOW_RISK',
          },
          {
            label: `ผู้มีคุณภาพชีวิตที่ไม่ดี `,
            value: 'WHOQOL_LOW',
          },
          {
            label: `การมีคุณภาพชีวิตกลางๆ`,
            value: 'WHOQOL_MEDIUM',
          },
          {
            label: `การมีคุณภาพชีวิตที่ดี`,
            value: 'WHOQOL_HIGH',
          },
          {
            label: `ผู้มีวิถีการดำเนินชีวิตอยู่ในเกณฑ์ดีมาก`,
            value: 'HPLP_VERY_GOOD',
          },
          {
            label: `ผู้มีวิถีการดำเนินชีวิตอยู่ในเกณฑ์ดี`,
            value: 'HPLP_GOOD',
          },
          {
            label: `ผู้มีวิถีการดำเนินชีวิตอยู่ในเกณฑ์พอใช้`,
            value: 'HPLP_FAIR',
          },
          {
            label: `ผู้มีวิถีการดำเนินชีวิตอยู่ในเกณฑ์ปรับปรุง`,
            value: 'HPLP_BAD',
          },
        ]"
        class="flex flex-col"
      />
    </a-form-item>

    <a-button @click="submit" class="text-white mt-16" type="primary" block
      >บันทึก</a-button
    >
  </div>
</template>

<script>
import Editor from "@/components/input/Editor.vue";
import PictureInput from "vue-picture-input";
import { storage } from "@/firebase.js";
import "@firebase/storage";

export default {
  props: {
    eLearning: {
      type: Object,
    },
  },
  components: {
    Editor,
    PictureInput,
  },
  data() {
    return {
      posterUrl: "",
      title: "",
      content: "",
      refUrl: "",
      targets: [],
    };
  },
  watch: {
    eLearning(value) {
      this.title = value.title;
      this.categoryId = value.categoryId;
      this.content = value.content;
    },
  },
  methods: {
    async onFeaturedImageChange(image) {
      let loader = this.$loading.show();

      this.uploadingFeaturedImage = true;

      const file = this.$refs.pictureInput.file;
      const metaData = {
        contentType: file.type,
      };

      const storageRef = storage.ref(`/health-recommendation/post-image/${Date.now()}`);

      try {
        const snapshot = await storageRef.put(file, metaData);
        const imageUrl = await snapshot.ref.getDownloadURL();

        this.posterUrl = imageUrl;
        this.uploadingFeaturedImage = false;

        loader.hide();
      } catch (error) {
        console.log(error);
        this.uploadingFeaturedImage = false;

        loader.hide();
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    submit() {
      const { posterUrl, title, content, refUrl, targets } = this;

      this.$emit("submit", { posterUrl, title, content, refUrl, targets });
    },
  },
};
</script>

<style>
.picture-preview {
  object-fit: contain !important;
}
</style>
